import {Link} from "react-router-dom";

type Props = {
    duration: string;
    title: string;
    imageUrl: string;
    urlContent: string;
};

const VideoSectionComponent: React.FC<Props> = ({ duration, title , imageUrl, urlContent}) => {
    return (
        <div className="d-flex">
            <div className={'thumbnail-div'} style={{ backgroundImage: `url(${imageUrl})` }}>
                <div className="video-duration-style">
                    <span className="text-white text-xs px-1 py-0.5">{duration}</span>
                </div>
            </div>
            {/* Video Title */}
            <Link to={urlContent} target={"_blank"} className="thumbnail-question-title">{title}</Link>
        </div>
    );
};

export default VideoSectionComponent;
